import React, { useState, useEffect } from 'react';
import LoginForm from './components/LoginForm';
import LoggedIn from './components/LoggedIn';
import { Amplify } from 'aws-amplify';

const App: React.FC = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [configLoaded, setConfigLoaded] = useState(false);

  useEffect(() => {
    // 設定ファイルをfetchで取得
    fetch('/aws-config.json')
      .then(res => res.json())
      .then(config => {
        Amplify.configure(config);
        setConfigLoaded(true);
      })
      .catch(err => {
        // エラー時の処理（必要に応じて）
        console.error('設定ファイルの読み込みに失敗しました', err);
      });
  }, []);

  if (!configLoaded) {
    // 設定ファイルのロード中はローディング表示
    return <div>Loading...</div>;
  }

  return (
    <div>
      {/* 画面遷移制御 */}
      {isLoggedIn ? (
        <LoggedIn onBack={() => setIsLoggedIn(false)} />
      ) : (
        <LoginForm onLoginSuccess={() => setIsLoggedIn(true)} />
      )}
    </div>
  );
};

export default App;
